export default __webpack_public_path__ + "static/media/event-wall-1.01fdb502.jpg";